import { Col, Row } from "antd";
import "./Video.css";
import { useRef, useState } from "react";

const Video = ({ video }) => {
  // const [showControls, setShowControls] = useState(false)
  const [activeVideo, setActiveVideo] = useState(null);
  const videoRefs = useRef({});

  const videosData = [
    {
      id: 1,
      title: "OUR JOURNEY & PROJECTS",
      description:
        "An overview of our growth, major projects, and key milestones.",
      src: "/videos/01-journey.mp4",
      thumbnail: "/video-thumbnails/video-1.png",
    },
    {
      id: 2,
      title: "AWARDS & CERTIFICATES",
      description:
        "A showcase of recognitions and certifications reflecting excellence.",
      src: "/videos/02-awards.mp4",
      thumbnail: "/video-thumbnails/video-2.png",
    },
    {
      id: 3,
      title: "QUALITY & SAFETY",
      description:
        "Our commitment to maintaining the highest quality and safety standards.",
      src: "/videos/03-quality.mp4",
      thumbnail: "/video-thumbnails/video-3.png",
    },
    {
      id: 4,
      title: "TECHNOLOGY",
      description: "Innovative technologies driving operational efficiency.",
      src: "/videos/04-technology.mp4",
      thumbnail: "/video-thumbnails/video-4.png",
    },
    {
      id: 5,
      title: "CSR",
      description:
        "Corporate social responsibility initiatives focused on sustainability.",
      src: "/videos/05-csr.mp4",
      thumbnail: "/video-thumbnails/video-5.png",
    },
  ];

  return (
    <>
      <img
        src="/Sources/images/banner/videos-bg.jpeg"
        alt="404 -Not Given"
        className="about_img"
        // style={{ marginLeft: window.innerWidth > 1355 ? "5%" : "" }}
      />
      <section className="video mobile_margin">
        <div className="section_padding"></div>
        <div className="container">
          <div>
            <div>
              <p
                style={{ color: "#0d2e61" }}
                className="is-size-2 has-text-weight-semibold has-text-centered mb-2"
              >
                Videos
              </p>
            </div>
          </div>
          <Row
            gutter={[32, 32]}
            style={{ marginTop: "30px", marginBottom: "60px" }}
          >
            {videosData.map((video) => (
              <Col xs={24} sm={24} md={12} lg={12} key={video.id}>
                <div>
                  <div
                    className="video-wrapper"
                    onClick={() => {
                      const currentVideo = videoRefs.current[video.id];

                      if (!currentVideo) return;

                      if (activeVideo === video.id) {
                        currentVideo.pause();
                        setActiveVideo(null);
                      } else {
                        Object.values(videoRefs.current).forEach((vid) => {
                          if (vid && vid !== currentVideo) vid.pause();
                        });

                        setActiveVideo(video.id);

                        setTimeout(() => {
                          currentVideo.play();
                        }, 0);
                      }
                    }}
                  >
                    <video
                      ref={(el) => (videoRefs.current[video.id] = el)}
                      controls={activeVideo === video.id}
                      preload="metadata"
                      poster={video.thumbnail}
                      playsInline
                    >
                      <source src={video.src} type="video/mp4" />
                    </video>

                    {activeVideo !== video.id && (
                      <div className="video-overlay">
                        <div className="play-icon"></div>
                      </div>
                    )}
                  </div>

                  <h3 className="video-title">{video.title}</h3>
                  <p className="video-description">{video.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>
    </>
  );
};

export default Video;
